import React from 'react';
import { Field } from 'react-final-form';
import { FormApi } from 'final-form';
import WeddingLocationLookaheadAdapter from '../WeddingLocationLookaheadAdapter';
import { baseSuggestion } from '../../../../../../helpers/weddingLocation';
import styles from '../../WeddingDetails.module.less';
import { WeddingDetailsFormType } from '../../util/types';

type FieldLocationProps = {
  formMutators: FormApi<WeddingDetailsFormType>;
};

const FieldLocation: React.FC<FieldLocationProps> = ({ formMutators: { change } }) => {
  // validation for city checks for comma-delimited string value for now
  const cityStateValidator = (value: string): string | undefined =>
    value && value !== baseSuggestion.name && value.indexOf(',') === -1
      ? 'Location must be in City, State format, separated by a comma'
      : undefined;

  return (
    <Field
      containerClassname={styles.locationInputField}
      name="location"
      label="Location"
      placeholder="City, State"
      component={WeddingLocationLookaheadAdapter}
      validate={cityStateValidator}
      type="text"
      helperText="eg. New York, NY"
      inputOnFocus={(event: React.FocusEvent<HTMLInputElement>): void => event.target.select()}
      allowChangeToEmpty
      clear
      onClear={(): void => change('location', '')}
    />
  );
};

export default FieldLocation;



// WEBPACK FOOTER //
// ./src/pages/settings/wedding/WeddingDetails/components/FieldLocation/FieldLocation.tsx